import React from 'react';
import MuiPopper from '@mui/material/Popper';

const Popper = (props) => <MuiPopper {...props} />;

export default Popper;
